module.exports = dibs_vendor;


//////////////////
// WEBPACK FOOTER
// external "dibs_vendor"
// module id = 67
// module chunks = 62